import {
    bootstrapCalendarBoard,
    retryLoadCalendarBoardProjects,
} from '../utils/calendarBoardUtils';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { observer } from 'mobx-react-lite';
import { CalendarBoardWelcome } from 'owa-calendar-board-welcome';
import { isFeatureEnabled } from 'owa-feature-flags';
import loc from 'owa-localize';
import { useAction } from 'owa-react-hooks/lib/useAction';
import { PointerEventsProvider } from 'owa-react-hooks/lib/usePointerEvents';
import {
    openTimeStreamProject,
    hasSelectedProject,
    deleteTimeStreamProject,
} from 'owa-timestream-store';
import { LazyTimeStreamCanvas } from 'owa-timestream-canvas';
import { Loading, NetworkError } from 'owa-timestream-loadingpanel';
import { TimeStreamQuickSwitcher } from 'owa-timestream-quick-switcher';
import * as React from 'react';
import {
    getDefaultBoardProject,
    hasLoadedDefaultBoardProject,
    isLoadingCalendarBoardProject,
    didLoadingCalendarBoardProjectFail,
    logDefaultCalendarBoardLoadState,
    isDefaultBoardProjectOpen,
} from 'owa-calendar-board-projects';
import { loadingBoardFailedMessage } from '../CalendarBoard.locstring.json';
import type { CalendarBoardProps } from '../schema';
import { CalendarBoardTeaching, MultiBoardTeaching } from 'owa-calendar-board-teaching';
import * as styles from './styles.scss';

export default observer(function CalendarBoardProject({
    assetRegistry,
    canvasBounds,
}: CalendarBoardProps) {
    useAction(bootstrapCalendarBoard);

    const project = getDefaultBoardProject();
    React.useEffect(() => {
        if (project && !hasSelectedProject()) {
            // TODO: VSO 109581 - open most recently viewed project
            openTimeStreamProject(project.projectId);
        }
    }, [project?.projectId]);

    const retryLoadProject = React.useCallback(() => {
        retryLoadCalendarBoardProjects(canvasBounds);
    }, [canvasBounds]);

    const deleteProject = React.useCallback(() => {
        if (project) {
            deleteTimeStreamProject(project.projectId);
        }
    }, [project?.projectId]);

    if (!hasLoadedDefaultBoardProject()) {
        if (isLoadingCalendarBoardProject()) {
            return <Loading />;
        }
        if (didLoadingCalendarBoardProjectFail()) {
            logDefaultCalendarBoardLoadState();
            return (
                <NetworkError
                    errorMessage={loc(loadingBoardFailedMessage)}
                    onRetry={retryLoadProject}
                />
            );
        }

        return <CalendarBoardWelcome canvasBounds={canvasBounds} />;
    }

    if (!assetRegistry) {
        return <Loading />;
    }

    logDefaultCalendarBoardLoadState();

    return (
        <PointerEventsProvider value={false}>
            <LazyTimeStreamCanvas assetRegistry={assetRegistry} />
            <TimeStreamQuickSwitcher />
            {isFeatureEnabled('cal-board-dev-deleteDefaultProject') &&
                isDefaultBoardProjectOpen() && (
                    <PrimaryButton
                        className={styles.devDeleteButton}
                        onClick={deleteProject}
                        text={'DELETE'}
                    />
                )}
            <CalendarBoardTeaching />
            <MultiBoardTeaching />
        </PointerEventsProvider>
    );
});
